import { render, staticRenderFns } from "./TrainingSchedule.vue?vue&type=template&id=3c6a6e3c&"
import script from "./TrainingSchedule.vue?vue&type=script&lang=js&"
export * from "./TrainingSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports